module.exports = __webpack_public_path__ + "static/media/unidanfe_image_full.2bdf28fe.webp";